import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GerarCobrancaResponse } from '../../responses/orquestrador-financas/gerar-cobranca.response';

@Injectable({ providedIn: 'root' })
export class GerarCobrancaService extends CommonService {
    private apiUrl: string = environment.urlApiOrquestradorFinancas + 'GerarCobranca';

    constructor(private httpClient: HttpClient) { super(); }

    public gerarCobranca(idContasReceberParcela: number): Observable<GerarCobrancaResponse> {
        return this.httpClient
            .post<GerarCobrancaResponse>(
                `${this.apiUrl}/${idContasReceberParcela}`,
                {},
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError.bind(this)));
    }
}
